
import { defineComponent } from 'vue'
import PatientRegistration from '../components/registration/PatientRegistration.vue'

export default defineComponent({
  name: 'RegistrationView',
  components: { PatientRegistration }
})
